/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 5.26.1
 * source: int/activity/api/activity.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */

/*
	此处请修改为Creator NpmExport路径
	请注意路径的层级
 */
import * as pb_1 from 'google-protobuf'
export namespace Activity {
  /**
      //////////////API  协议////////////////////////////////////////
       奖励类型
       **/
  export enum AwardType {
    /**
          金币
           **/
    GOLD = 0,

    /**
          礼金
           **/
    BONUS = 1,
  }

  /**
      打脸类型
       **/
  export enum SLAP {
    /**
          不打脸
           **/
    NONE = 0,

    /**
          每天打脸一次，英文名有歧义，为了兼容之前，暂时不修改
           **/
    ONCE = 1,

    /**
          每天打脸多次，英文名有歧义，为了兼容之前，暂时不修改
           **/
    EVERY = 2,
  }

  /**
      通用请求头
       **/
  export class ReqHeader extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            timestamp?: number
            user_id?: number
            token?: string
            aid?: string
            code?: string
            svn?: string
            svc?: string
            cvn?: string
            cvc?: string
            chn?: string
            pkg?: string
            brd?: string
            eid?: string
            mer_code?: string
            app?: number
            lan?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('timestamp' in data && data.timestamp != undefined) {
          this.timestamp = data.timestamp
        }
        if ('user_id' in data && data.user_id != undefined) {
          this.user_id = data.user_id
        }
        if ('token' in data && data.token != undefined) {
          this.token = data.token
        }
        if ('aid' in data && data.aid != undefined) {
          this.aid = data.aid
        }
        if ('code' in data && data.code != undefined) {
          this.code = data.code
        }
        if ('svn' in data && data.svn != undefined) {
          this.svn = data.svn
        }
        if ('svc' in data && data.svc != undefined) {
          this.svc = data.svc
        }
        if ('cvn' in data && data.cvn != undefined) {
          this.cvn = data.cvn
        }
        if ('cvc' in data && data.cvc != undefined) {
          this.cvc = data.cvc
        }
        if ('chn' in data && data.chn != undefined) {
          this.chn = data.chn
        }
        if ('pkg' in data && data.pkg != undefined) {
          this.pkg = data.pkg
        }
        if ('brd' in data && data.brd != undefined) {
          this.brd = data.brd
        }
        if ('eid' in data && data.eid != undefined) {
          this.eid = data.eid
        }
        if ('mer_code' in data && data.mer_code != undefined) {
          this.mer_code = data.mer_code
        }
        if ('app' in data && data.app != undefined) {
          this.app = data.app
        }
        if ('lan' in data && data.lan != undefined) {
          this.lan = data.lan
        }
      }
    }
    get timestamp() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }
    set timestamp(value: number) {
      pb_1.Message.setField(this, 1, value)
    }
    get user_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set user_id(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    get token() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }
    set token(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          活动相关参数
           设备号
           **/
    get aid() {
      return pb_1.Message.getFieldWithDefault(this, 50, '') as string
    }

    /**
          活动相关参数
           设备号
           **/
    set aid(value: string) {
      pb_1.Message.setField(this, 50, value)
    }

    /**
          国家码
           **/
    get code() {
      return pb_1.Message.getFieldWithDefault(this, 51, '') as string
    }

    /**
          国家码
           **/
    set code(value: string) {
      pb_1.Message.setField(this, 51, value)
    }

    /**
          系统类型 : a, i, h
           **/
    get svn() {
      return pb_1.Message.getFieldWithDefault(this, 52, '') as string
    }

    /**
          系统类型 : a, i, h
           **/
    set svn(value: string) {
      pb_1.Message.setField(this, 52, value)
    }

    /**
          系统版本号 ios: 12.1.4
           **/
    get svc() {
      return pb_1.Message.getFieldWithDefault(this, 53, '') as string
    }

    /**
          系统版本号 ios: 12.1.4
           **/
    set svc(value: string) {
      pb_1.Message.setField(this, 53, value)
    }

    /**
          client version name
           **/
    get cvn() {
      return pb_1.Message.getFieldWithDefault(this, 54, '') as string
    }

    /**
          client version name
           **/
    set cvn(value: string) {
      pb_1.Message.setField(this, 54, value)
    }

    /**
          cocos version code
           **/
    get cvc() {
      return pb_1.Message.getFieldWithDefault(this, 55, '') as string
    }

    /**
          cocos version code
           **/
    set cvc(value: string) {
      pb_1.Message.setField(this, 55, value)
    }

    /**
          渠道
           **/
    get chn() {
      return pb_1.Message.getFieldWithDefault(this, 56, '') as string
    }

    /**
          渠道
           **/
    set chn(value: string) {
      pb_1.Message.setField(this, 56, value)
    }

    /**
          包名
           **/
    get pkg() {
      return pb_1.Message.getFieldWithDefault(this, 57, '') as string
    }

    /**
          包名
           **/
    set pkg(value: string) {
      pb_1.Message.setField(this, 57, value)
    }

    /**
          品牌
           **/
    get brd() {
      return pb_1.Message.getFieldWithDefault(this, 58, '') as string
    }

    /**
          品牌
           **/
    set brd(value: string) {
      pb_1.Message.setField(this, 58, value)
    }

    /**
          trace id
           **/
    get eid() {
      return pb_1.Message.getFieldWithDefault(this, 59, '') as string
    }

    /**
          trace id
           **/
    set eid(value: string) {
      pb_1.Message.setField(this, 59, value)
    }
    get mer_code() {
      return pb_1.Message.getFieldWithDefault(this, 60, '') as string
    }
    set mer_code(value: string) {
      pb_1.Message.setField(this, 60, value)
    }

    /**
          应用ID
           **/
    get app() {
      return pb_1.Message.getFieldWithDefault(this, 100, 0) as number
    }

    /**
          应用ID
           **/
    set app(value: number) {
      pb_1.Message.setField(this, 100, value)
    }

    /**
          客户端当前语言，用于token失效场景时，服务端返回对应语言的提示
           **/
    get lan() {
      return pb_1.Message.getFieldWithDefault(this, 102, '') as string
    }

    /**
          客户端当前语言，用于token失效场景时，服务端返回对应语言的提示
           **/
    set lan(value: string) {
      pb_1.Message.setField(this, 102, value)
    }
    static fromObject(data: {
      timestamp?: number
      user_id?: number
      token?: string
      aid?: string
      code?: string
      svn?: string
      svc?: string
      cvn?: string
      cvc?: string
      chn?: string
      pkg?: string
      brd?: string
      eid?: string
      mer_code?: string
      app?: number
      lan?: string
    }): ReqHeader {
      const message = new ReqHeader({})
      if (data.timestamp != null) {
        message.timestamp = data.timestamp
      }
      if (data.user_id != null) {
        message.user_id = data.user_id
      }
      if (data.token != null) {
        message.token = data.token
      }
      if (data.aid != null) {
        message.aid = data.aid
      }
      if (data.code != null) {
        message.code = data.code
      }
      if (data.svn != null) {
        message.svn = data.svn
      }
      if (data.svc != null) {
        message.svc = data.svc
      }
      if (data.cvn != null) {
        message.cvn = data.cvn
      }
      if (data.cvc != null) {
        message.cvc = data.cvc
      }
      if (data.chn != null) {
        message.chn = data.chn
      }
      if (data.pkg != null) {
        message.pkg = data.pkg
      }
      if (data.brd != null) {
        message.brd = data.brd
      }
      if (data.eid != null) {
        message.eid = data.eid
      }
      if (data.mer_code != null) {
        message.mer_code = data.mer_code
      }
      if (data.app != null) {
        message.app = data.app
      }
      if (data.lan != null) {
        message.lan = data.lan
      }
      return message
    }
    toObject() {
      const data: {
        timestamp?: number
        user_id?: number
        token?: string
        aid?: string
        code?: string
        svn?: string
        svc?: string
        cvn?: string
        cvc?: string
        chn?: string
        pkg?: string
        brd?: string
        eid?: string
        mer_code?: string
        app?: number
        lan?: string
      } = {}
      if (this.timestamp != null) {
        data.timestamp = this.timestamp
      }
      if (this.user_id != null) {
        data.user_id = this.user_id
      }
      if (this.token != null) {
        data.token = this.token
      }
      if (this.aid != null) {
        data.aid = this.aid
      }
      if (this.code != null) {
        data.code = this.code
      }
      if (this.svn != null) {
        data.svn = this.svn
      }
      if (this.svc != null) {
        data.svc = this.svc
      }
      if (this.cvn != null) {
        data.cvn = this.cvn
      }
      if (this.cvc != null) {
        data.cvc = this.cvc
      }
      if (this.chn != null) {
        data.chn = this.chn
      }
      if (this.pkg != null) {
        data.pkg = this.pkg
      }
      if (this.brd != null) {
        data.brd = this.brd
      }
      if (this.eid != null) {
        data.eid = this.eid
      }
      if (this.mer_code != null) {
        data.mer_code = this.mer_code
      }
      if (this.app != null) {
        data.app = this.app
      }
      if (this.lan != null) {
        data.lan = this.lan
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.timestamp != 0) writer.writeInt64(1, this.timestamp)
      if (this.user_id != 0) writer.writeUint64(2, this.user_id)
      if (this.token.length) writer.writeString(3, this.token)
      if (this.aid.length) writer.writeString(50, this.aid)
      if (this.code.length) writer.writeString(51, this.code)
      if (this.svn.length) writer.writeString(52, this.svn)
      if (this.svc.length) writer.writeString(53, this.svc)
      if (this.cvn.length) writer.writeString(54, this.cvn)
      if (this.cvc.length) writer.writeString(55, this.cvc)
      if (this.chn.length) writer.writeString(56, this.chn)
      if (this.pkg.length) writer.writeString(57, this.pkg)
      if (this.brd.length) writer.writeString(58, this.brd)
      if (this.eid.length) writer.writeString(59, this.eid)
      if (this.mer_code.length) writer.writeString(60, this.mer_code)
      if (Number(this.app)) writer.writeInt32(100, this.app)
      if (this.lan.length) writer.writeString(102, this.lan)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ReqHeader {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ReqHeader()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.timestamp = reader.readInt64()
            break
          case 2:
            message.user_id = reader.readUint64()
            break
          case 3:
            message.token = reader.readString()
            break
          case 50:
            message.aid = reader.readString()
            break
          case 51:
            message.code = reader.readString()
            break
          case 52:
            message.svn = reader.readString()
            break
          case 53:
            message.svc = reader.readString()
            break
          case 54:
            message.cvn = reader.readString()
            break
          case 55:
            message.cvc = reader.readString()
            break
          case 56:
            message.chn = reader.readString()
            break
          case 57:
            message.pkg = reader.readString()
            break
          case 58:
            message.brd = reader.readString()
            break
          case 59:
            message.eid = reader.readString()
            break
          case 60:
            message.mer_code = reader.readString()
            break
          case 100:
            message.app = reader.readInt32()
            break
          case 102:
            message.lan = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ReqHeader {
      return ReqHeader.deserialize(bytes)
    }
  }

  /**
      通用应答头
       **/
  export class RespHeader extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            code?: number
            trace_id?: string
            msg?: string
            timestamp?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('code' in data && data.code != undefined) {
          this.code = data.code
        }
        if ('trace_id' in data && data.trace_id != undefined) {
          this.trace_id = data.trace_id
        }
        if ('msg' in data && data.msg != undefined) {
          this.msg = data.msg
        }
        if ('timestamp' in data && data.timestamp != undefined) {
          this.timestamp = data.timestamp
        }
      }
    }

    /**
          各模块接口定义的业务异常码
           **/
    get code() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }

    /**
          各模块接口定义的业务异常码
           **/
    set code(value: number) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          本次请求唯一事务id，用于问题追踪定位
           **/
    get trace_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          本次请求唯一事务id，用于问题追踪定位
           **/
    set trace_id(value: string) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          错误信息
           **/
    get msg() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          错误信息
           **/
    set msg(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          当前时间截
           **/
    get timestamp() {
      return pb_1.Message.getFieldWithDefault(this, 4, 0) as number
    }

    /**
          当前时间截
           **/
    set timestamp(value: number) {
      pb_1.Message.setField(this, 4, value)
    }
    static fromObject(data: {
      code?: number
      trace_id?: string
      msg?: string
      timestamp?: number
    }): RespHeader {
      const message = new RespHeader({})
      if (data.code != null) {
        message.code = data.code
      }
      if (data.trace_id != null) {
        message.trace_id = data.trace_id
      }
      if (data.msg != null) {
        message.msg = data.msg
      }
      if (data.timestamp != null) {
        message.timestamp = data.timestamp
      }
      return message
    }
    toObject() {
      const data: {
        code?: number
        trace_id?: string
        msg?: string
        timestamp?: number
      } = {}
      if (this.code != null) {
        data.code = this.code
      }
      if (this.trace_id != null) {
        data.trace_id = this.trace_id
      }
      if (this.msg != null) {
        data.msg = this.msg
      }
      if (this.timestamp != null) {
        data.timestamp = this.timestamp
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.code != 0) writer.writeInt32(1, this.code)
      if (this.trace_id.length) writer.writeString(2, this.trace_id)
      if (this.msg.length) writer.writeString(3, this.msg)
      if (this.timestamp != 0) writer.writeInt64(4, this.timestamp)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespHeader {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new RespHeader()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.code = reader.readInt32()
            break
          case 2:
            message.trace_id = reader.readString()
            break
          case 3:
            message.msg = reader.readString()
            break
          case 4:
            message.timestamp = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): RespHeader {
      return RespHeader.deserialize(bytes)
    }
  }

  /**
      分页参数
       **/
  export class PaginationCriteria extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            page_no?: number
            page_size?: number
            return_total?: boolean
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('page_no' in data && data.page_no != undefined) {
          this.page_no = data.page_no
        }
        if ('page_size' in data && data.page_size != undefined) {
          this.page_size = data.page_size
        }
        if ('return_total' in data && data.return_total != undefined) {
          this.return_total = data.return_total
        }
      }
    }
    get page_no() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }
    set page_no(value: number) {
      pb_1.Message.setField(this, 1, value)
    }
    get page_size() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }
    set page_size(value: number) {
      pb_1.Message.setField(this, 2, value)
    }
    get return_total() {
      return pb_1.Message.getFieldWithDefault(this, 3, false) as boolean
    }
    set return_total(value: boolean) {
      pb_1.Message.setField(this, 3, value)
    }
    static fromObject(data: {
      page_no?: number
      page_size?: number
      return_total?: boolean
    }): PaginationCriteria {
      const message = new PaginationCriteria({})
      if (data.page_no != null) {
        message.page_no = data.page_no
      }
      if (data.page_size != null) {
        message.page_size = data.page_size
      }
      if (data.return_total != null) {
        message.return_total = data.return_total
      }
      return message
    }
    toObject() {
      const data: {
        page_no?: number
        page_size?: number
        return_total?: boolean
      } = {}
      if (this.page_no != null) {
        data.page_no = this.page_no
      }
      if (this.page_size != null) {
        data.page_size = this.page_size
      }
      if (this.return_total != null) {
        data.return_total = this.return_total
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.page_no != 0) writer.writeInt32(1, this.page_no)
      if (this.page_size != 0) writer.writeInt32(2, this.page_size)
      if (this.return_total != false) writer.writeBool(3, this.return_total)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaginationCriteria {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new PaginationCriteria()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.page_no = reader.readInt32()
            break
          case 2:
            message.page_size = reader.readInt32()
            break
          case 3:
            message.return_total = reader.readBool()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): PaginationCriteria {
      return PaginationCriteria.deserialize(bytes)
    }
  }
  export class Activity extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            app?: number
            effected_at?: number
            expired_at?: number
            conf_id?: string
            countdown?: number
            unreads?: number
            tips?: string
            notify?: boolean
            icon?: string
            slap?: SLAP
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('app' in data && data.app != undefined) {
          this.app = data.app
        }
        if ('effected_at' in data && data.effected_at != undefined) {
          this.effected_at = data.effected_at
        }
        if ('expired_at' in data && data.expired_at != undefined) {
          this.expired_at = data.expired_at
        }
        if ('conf_id' in data && data.conf_id != undefined) {
          this.conf_id = data.conf_id
        }
        if ('countdown' in data && data.countdown != undefined) {
          this.countdown = data.countdown
        }
        if ('unreads' in data && data.unreads != undefined) {
          this.unreads = data.unreads
        }
        if ('tips' in data && data.tips != undefined) {
          this.tips = data.tips
        }
        if ('notify' in data && data.notify != undefined) {
          this.notify = data.notify
        }
        if ('icon' in data && data.icon != undefined) {
          this.icon = data.icon
        }
        if ('slap' in data && data.slap != undefined) {
          this.slap = data.slap
        }
      }
    }

    /**
          活动应用ID
           **/
    get app() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }

    /**
          活动应用ID
           **/
    set app(value: number) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          生效时间
           **/
    get effected_at() {
      return pb_1.Message.getFieldWithDefault(this, 2, 0) as number
    }

    /**
          生效时间
           **/
    set effected_at(value: number) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          过期时间
           **/
    get expired_at() {
      return pb_1.Message.getFieldWithDefault(this, 3, 0) as number
    }

    /**
          过期时间
           **/
    set expired_at(value: number) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          配置ID
           **/
    get conf_id() {
      return pb_1.Message.getFieldWithDefault(this, 4, '') as string
    }

    /**
          配置ID
           **/
    set conf_id(value: string) {
      pb_1.Message.setField(this, 4, value)
    }

    /**
          倒计时
           **/
    get countdown() {
      return pb_1.Message.getFieldWithDefault(this, 5, 0) as number
    }

    /**
          倒计时
           **/
    set countdown(value: number) {
      pb_1.Message.setField(this, 5, value)
    }

    /**
          未读数
           **/
    get unreads() {
      return pb_1.Message.getFieldWithDefault(this, 6, 0) as number
    }

    /**
          未读数
           **/
    set unreads(value: number) {
      pb_1.Message.setField(this, 6, value)
    }

    /**
          提示文本
           **/
    get tips() {
      return pb_1.Message.getFieldWithDefault(this, 7, '') as string
    }

    /**
          提示文本
           **/
    set tips(value: string) {
      pb_1.Message.setField(this, 7, value)
    }

    /**
          是否有通知(红点)，true有，false没有
           **/
    get notify() {
      return pb_1.Message.getFieldWithDefault(this, 8, false) as boolean
    }

    /**
          是否有通知(红点)，true有，false没有
           **/
    set notify(value: boolean) {
      pb_1.Message.setField(this, 8, value)
    }

    /**
          图标icon
           **/
    get icon() {
      return pb_1.Message.getFieldWithDefault(this, 9, '') as string
    }

    /**
          图标icon
           **/
    set icon(value: string) {
      pb_1.Message.setField(this, 9, value)
    }

    /**
          打脸类型
           **/
    get slap() {
      return pb_1.Message.getFieldWithDefault(this, 10, SLAP.NONE) as SLAP
    }

    /**
          打脸类型
           **/
    set slap(value: SLAP) {
      pb_1.Message.setField(this, 10, value)
    }
    static fromObject(data: {
      app?: number
      effected_at?: number
      expired_at?: number
      conf_id?: string
      countdown?: number
      unreads?: number
      tips?: string
      notify?: boolean
      icon?: string
      slap?: SLAP
    }): Activity {
      const message = new Activity({})
      if (data.app != null) {
        message.app = data.app
      }
      if (data.effected_at != null) {
        message.effected_at = data.effected_at
      }
      if (data.expired_at != null) {
        message.expired_at = data.expired_at
      }
      if (data.conf_id != null) {
        message.conf_id = data.conf_id
      }
      if (data.countdown != null) {
        message.countdown = data.countdown
      }
      if (data.unreads != null) {
        message.unreads = data.unreads
      }
      if (data.tips != null) {
        message.tips = data.tips
      }
      if (data.notify != null) {
        message.notify = data.notify
      }
      if (data.icon != null) {
        message.icon = data.icon
      }
      if (data.slap != null) {
        message.slap = data.slap
      }
      return message
    }
    toObject() {
      const data: {
        app?: number
        effected_at?: number
        expired_at?: number
        conf_id?: string
        countdown?: number
        unreads?: number
        tips?: string
        notify?: boolean
        icon?: string
        slap?: SLAP
      } = {}
      if (this.app != null) {
        data.app = this.app
      }
      if (this.effected_at != null) {
        data.effected_at = this.effected_at
      }
      if (this.expired_at != null) {
        data.expired_at = this.expired_at
      }
      if (this.conf_id != null) {
        data.conf_id = this.conf_id
      }
      if (this.countdown != null) {
        data.countdown = this.countdown
      }
      if (this.unreads != null) {
        data.unreads = this.unreads
      }
      if (this.tips != null) {
        data.tips = this.tips
      }
      if (this.notify != null) {
        data.notify = this.notify
      }
      if (this.icon != null) {
        data.icon = this.icon
      }
      if (this.slap != null) {
        data.slap = this.slap
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.app != 0) writer.writeInt32(1, this.app)
      if (this.effected_at != 0) writer.writeInt64(2, this.effected_at)
      if (this.expired_at != 0) writer.writeInt64(3, this.expired_at)
      if (this.conf_id.length) writer.writeString(4, this.conf_id)
      if (this.countdown != 0) writer.writeInt64(5, this.countdown)
      if (this.unreads != 0) writer.writeInt32(6, this.unreads)
      if (this.tips.length) writer.writeString(7, this.tips)
      if (this.notify != false) writer.writeBool(8, this.notify)
      if (this.icon.length) writer.writeString(9, this.icon)
      if (this.slap != SLAP.NONE) writer.writeEnum(10, this.slap)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Activity {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new Activity()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.app = reader.readInt32()
            break
          case 2:
            message.effected_at = reader.readInt64()
            break
          case 3:
            message.expired_at = reader.readInt64()
            break
          case 4:
            message.conf_id = reader.readString()
            break
          case 5:
            message.countdown = reader.readInt64()
            break
          case 6:
            message.unreads = reader.readInt32()
            break
          case 7:
            message.tips = reader.readString()
            break
          case 8:
            message.notify = reader.readBool()
            break
          case 9:
            message.icon = reader.readString()
            break
          case 10:
            message.slap = reader.readEnum()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): Activity {
      return Activity.deserialize(bytes)
    }
  }
  export class Gift extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            app?: number
            data?: Uint8Array
            title?: string
            recharge_amount?: number
            award_per?: number
            gold_award_amount?: number
            bonus_award_amount?: number
            expired_at?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('app' in data && data.app != undefined) {
          this.app = data.app
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
        if ('title' in data && data.title != undefined) {
          this.title = data.title
        }
        if ('recharge_amount' in data && data.recharge_amount != undefined) {
          this.recharge_amount = data.recharge_amount
        }
        if ('award_per' in data && data.award_per != undefined) {
          this.award_per = data.award_per
        }
        if ('gold_award_amount' in data && data.gold_award_amount != undefined) {
          this.gold_award_amount = data.gold_award_amount
        }
        if ('bonus_award_amount' in data && data.bonus_award_amount != undefined) {
          this.bonus_award_amount = data.bonus_award_amount
        }
        if ('expired_at' in data && data.expired_at != undefined) {
          this.expired_at = data.expired_at
        }
      }
    }

    /**
          活动应用ID
           **/
    get app() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }

    /**
          活动应用ID
           **/
    set app(value: number) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          备用扩展字段
           **/
    get data() {
      return pb_1.Message.getFieldWithDefault(this, 2, new Uint8Array(0)) as Uint8Array
    }

    /**
          备用扩展字段
           **/
    set data(value: Uint8Array) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          礼包标题
           **/
    get title() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          礼包标题
           **/
    set title(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          充值金额
           **/
    get recharge_amount() {
      return pb_1.Message.getFieldWithDefault(this, 4, 0) as number
    }

    /**
          充值金额
           **/
    set recharge_amount(value: number) {
      pb_1.Message.setField(this, 4, value)
    }

    /**
          奖励百分比
           **/
    get award_per() {
      return pb_1.Message.getFieldWithDefault(this, 5, 0) as number
    }

    /**
          奖励百分比
           **/
    set award_per(value: number) {
      pb_1.Message.setField(this, 5, value)
    }

    /**
          金币奖励金额
           **/
    get gold_award_amount() {
      return pb_1.Message.getFieldWithDefault(this, 6, 0) as number
    }

    /**
          金币奖励金额
           **/
    set gold_award_amount(value: number) {
      pb_1.Message.setField(this, 6, value)
    }

    /**
          bonus奖励金额
           **/
    get bonus_award_amount() {
      return pb_1.Message.getFieldWithDefault(this, 7, 0) as number
    }

    /**
          bonus奖励金额
           **/
    set bonus_award_amount(value: number) {
      pb_1.Message.setField(this, 7, value)
    }

    /**
          过期时间
           **/
    get expired_at() {
      return pb_1.Message.getFieldWithDefault(this, 8, 0) as number
    }

    /**
          过期时间
           **/
    set expired_at(value: number) {
      pb_1.Message.setField(this, 8, value)
    }
    static fromObject(data: {
      app?: number
      data?: Uint8Array
      title?: string
      recharge_amount?: number
      award_per?: number
      gold_award_amount?: number
      bonus_award_amount?: number
      expired_at?: number
    }): Gift {
      const message = new Gift({})
      if (data.app != null) {
        message.app = data.app
      }
      if (data.data != null) {
        message.data = data.data
      }
      if (data.title != null) {
        message.title = data.title
      }
      if (data.recharge_amount != null) {
        message.recharge_amount = data.recharge_amount
      }
      if (data.award_per != null) {
        message.award_per = data.award_per
      }
      if (data.gold_award_amount != null) {
        message.gold_award_amount = data.gold_award_amount
      }
      if (data.bonus_award_amount != null) {
        message.bonus_award_amount = data.bonus_award_amount
      }
      if (data.expired_at != null) {
        message.expired_at = data.expired_at
      }
      return message
    }
    toObject() {
      const data: {
        app?: number
        data?: Uint8Array
        title?: string
        recharge_amount?: number
        award_per?: number
        gold_award_amount?: number
        bonus_award_amount?: number
        expired_at?: number
      } = {}
      if (this.app != null) {
        data.app = this.app
      }
      if (this.data != null) {
        data.data = this.data
      }
      if (this.title != null) {
        data.title = this.title
      }
      if (this.recharge_amount != null) {
        data.recharge_amount = this.recharge_amount
      }
      if (this.award_per != null) {
        data.award_per = this.award_per
      }
      if (this.gold_award_amount != null) {
        data.gold_award_amount = this.gold_award_amount
      }
      if (this.bonus_award_amount != null) {
        data.bonus_award_amount = this.bonus_award_amount
      }
      if (this.expired_at != null) {
        data.expired_at = this.expired_at
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.app != 0) writer.writeInt32(1, this.app)
      if (this.data.length) writer.writeBytes(2, this.data)
      if (this.title.length) writer.writeString(3, this.title)
      if (this.recharge_amount != 0) writer.writeInt64(4, this.recharge_amount)
      if (this.award_per != 0) writer.writeDouble(5, this.award_per)
      if (this.gold_award_amount != 0) writer.writeInt64(6, this.gold_award_amount)
      if (this.bonus_award_amount != 0) writer.writeInt64(7, this.bonus_award_amount)
      if (this.expired_at != 0) writer.writeInt64(8, this.expired_at)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Gift {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new Gift()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.app = reader.readInt32()
            break
          case 2:
            message.data = reader.readBytes()
            break
          case 3:
            message.title = reader.readString()
            break
          case 4:
            message.recharge_amount = reader.readInt64()
            break
          case 5:
            message.award_per = reader.readDouble()
            break
          case 6:
            message.gold_award_amount = reader.readInt64()
            break
          case 7:
            message.bonus_award_amount = reader.readInt64()
            break
          case 8:
            message.expired_at = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): Gift {
      return Gift.deserialize(bytes)
    }
  }
  export class Summary extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            app?: number
            notify?: boolean
            award_amount?: number
            award_ratio?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('app' in data && data.app != undefined) {
          this.app = data.app
        }
        if ('notify' in data && data.notify != undefined) {
          this.notify = data.notify
        }
        if ('award_amount' in data && data.award_amount != undefined) {
          this.award_amount = data.award_amount
        }
        if ('award_ratio' in data && data.award_ratio != undefined) {
          this.award_ratio = data.award_ratio
        }
      }
    }

    /**
          活动应用ID
           **/
    get app() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }

    /**
          活动应用ID
           **/
    set app(value: number) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          是否有通知(红点)，true有，false没有
           **/
    get notify() {
      return pb_1.Message.getFieldWithDefault(this, 2, false) as boolean
    }

    /**
          是否有通知(红点)，true有，false没有
           **/
    set notify(value: boolean) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          金币奖励金额
           **/
    get award_amount() {
      return pb_1.Message.getFieldWithDefault(this, 3, 0) as number
    }

    /**
          金币奖励金额
           **/
    set award_amount(value: number) {
      pb_1.Message.setField(this, 3, value)
    }
    get award_ratio() {
      return pb_1.Message.getFieldWithDefault(this, 4, 0) as number
    }
    set award_ratio(value: number) {
      pb_1.Message.setField(this, 4, value)
    }
    static fromObject(data: {
      app?: number
      notify?: boolean
      award_amount?: number
      award_ratio?: number
    }): Summary {
      const message = new Summary({})
      if (data.app != null) {
        message.app = data.app
      }
      if (data.notify != null) {
        message.notify = data.notify
      }
      if (data.award_amount != null) {
        message.award_amount = data.award_amount
      }
      if (data.award_ratio != null) {
        message.award_ratio = data.award_ratio
      }
      return message
    }
    toObject() {
      const data: {
        app?: number
        notify?: boolean
        award_amount?: number
        award_ratio?: number
      } = {}
      if (this.app != null) {
        data.app = this.app
      }
      if (this.notify != null) {
        data.notify = this.notify
      }
      if (this.award_amount != null) {
        data.award_amount = this.award_amount
      }
      if (this.award_ratio != null) {
        data.award_ratio = this.award_ratio
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.app != 0) writer.writeInt32(1, this.app)
      if (this.notify != false) writer.writeBool(2, this.notify)
      if (this.award_amount != 0) writer.writeInt64(3, this.award_amount)
      if (this.award_ratio != 0) writer.writeDouble(4, this.award_ratio)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Summary {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new Summary()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.app = reader.readInt32()
            break
          case 2:
            message.notify = reader.readBool()
            break
          case 3:
            message.award_amount = reader.readInt64()
            break
          case 4:
            message.award_ratio = reader.readDouble()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): Summary {
      return Summary.deserialize(bytes)
    }
  }

  /**
      ///////////////////////通用活动入口数据获取///////////////////////////////
       获取活动列表
       **/
  export class ActivitiesReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            apps?: number[]
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('apps' in data && data.apps != undefined) {
          this.apps = data.apps
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get apps() {
      return pb_1.Message.getFieldWithDefault(this, 2, []) as number[]
    }
    set apps(value: number[]) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      apps?: number[]
    }): ActivitiesReq {
      const message = new ActivitiesReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.apps != null) {
        message.apps = data.apps
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        apps?: number[]
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.apps != null) {
        data.apps = this.apps
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.apps.length) writer.writePackedInt32(2, this.apps)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActivitiesReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActivitiesReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.apps = reader.readPackedInt32()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActivitiesReq {
      return ActivitiesReq.deserialize(bytes)
    }
  }
  export class ActivitiesResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: ActivitiesResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(
        this,
        ActivitiesResp.RespData,
        2
      ) as ActivitiesResp.RespData
    }
    set data(value: ActivitiesResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof ActivitiesResp.RespData.prototype.toObject>
    }): ActivitiesResp {
      const message = new ActivitiesResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = ActivitiesResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof ActivitiesResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActivitiesResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActivitiesResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = ActivitiesResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActivitiesResp {
      return ActivitiesResp.deserialize(bytes)
    }
  }
  export namespace ActivitiesResp {
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              activities?: Activity[]
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [1],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('activities' in data && data.activities != undefined) {
            this.activities = data.activities
          }
        }
      }
      get activities() {
        return pb_1.Message.getRepeatedWrapperField(this, Activity, 1) as Activity[]
      }
      set activities(value: Activity[]) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value)
      }
      static fromObject(data: {
        activities?: ReturnType<typeof Activity.prototype.toObject>[]
      }): RespData {
        const message = new RespData({})
        if (data.activities != null) {
          message.activities = data.activities.map((item) => Activity.fromObject(item))
        }
        return message
      }
      toObject() {
        const data: {
          activities?: ReturnType<typeof Activity.prototype.toObject>[]
        } = {}
        if (this.activities != null) {
          data.activities = this.activities.map((item: Activity) => item.toObject())
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.activities.length)
          writer.writeRepeatedMessage(1, this.activities, (item: Activity) =>
            item.serialize(writer)
          )
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(message.activities, () =>
                pb_1.Message.addToRepeatedWrapperField(
                  message,
                  1,
                  Activity.deserialize(reader),
                  Activity
                )
              )
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      获取指定活动信息
       **/
  export class ActivityReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
    }): ActivityReq {
      const message = new ActivityReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActivityReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActivityReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActivityReq {
      return ActivityReq.deserialize(bytes)
    }
  }
  export class ActivityResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: ActivityResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(this, ActivityResp.RespData, 2) as ActivityResp.RespData
    }
    set data(value: ActivityResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof ActivityResp.RespData.prototype.toObject>
    }): ActivityResp {
      const message = new ActivityResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = ActivityResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof ActivityResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActivityResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActivityResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = ActivityResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActivityResp {
      return ActivityResp.deserialize(bytes)
    }
  }
  export namespace ActivityResp {
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              activity?: Activity
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('activity' in data && data.activity != undefined) {
            this.activity = data.activity
          }
        }
      }
      get activity() {
        return pb_1.Message.getWrapperField(this, Activity, 1) as Activity
      }
      set activity(value: Activity) {
        pb_1.Message.setWrapperField(this, 1, value)
      }
      get has_activity() {
        return pb_1.Message.getField(this, 1) != null
      }
      static fromObject(data: {
        activity?: ReturnType<typeof Activity.prototype.toObject>
      }): RespData {
        const message = new RespData({})
        if (data.activity != null) {
          message.activity = Activity.fromObject(data.activity)
        }
        return message
      }
      toObject() {
        const data: {
          activity?: ReturnType<typeof Activity.prototype.toObject>
        } = {}
        if (this.activity != null) {
          data.activity = this.activity.toObject()
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.has_activity)
          writer.writeMessage(1, this.activity, () => this.activity.serialize(writer))
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(
                message.activity,
                () => (message.activity = Activity.deserialize(reader))
              )
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      ///////////////////////通用礼包数据获取///////////////////////////////
       获取礼包列表
       **/
  export class GiftsReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            apps?: number[]
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('apps' in data && data.apps != undefined) {
          this.apps = data.apps
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get apps() {
      return pb_1.Message.getFieldWithDefault(this, 2, []) as number[]
    }
    set apps(value: number[]) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      apps?: number[]
    }): GiftsReq {
      const message = new GiftsReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.apps != null) {
        message.apps = data.apps
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        apps?: number[]
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.apps != null) {
        data.apps = this.apps
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.apps.length) writer.writePackedInt32(2, this.apps)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GiftsReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GiftsReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.apps = reader.readPackedInt32()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GiftsReq {
      return GiftsReq.deserialize(bytes)
    }
  }
  export class GiftsResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: GiftsResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(this, GiftsResp.RespData, 2) as GiftsResp.RespData
    }
    set data(value: GiftsResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof GiftsResp.RespData.prototype.toObject>
    }): GiftsResp {
      const message = new GiftsResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = GiftsResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof GiftsResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GiftsResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GiftsResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = GiftsResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GiftsResp {
      return GiftsResp.deserialize(bytes)
    }
  }
  export namespace GiftsResp {
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              gifts?: Gift[]
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [1],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('gifts' in data && data.gifts != undefined) {
            this.gifts = data.gifts
          }
        }
      }
      get gifts() {
        return pb_1.Message.getRepeatedWrapperField(this, Gift, 1) as Gift[]
      }
      set gifts(value: Gift[]) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value)
      }
      static fromObject(data: { gifts?: ReturnType<typeof Gift.prototype.toObject>[] }): RespData {
        const message = new RespData({})
        if (data.gifts != null) {
          message.gifts = data.gifts.map((item) => Gift.fromObject(item))
        }
        return message
      }
      toObject() {
        const data: {
          gifts?: ReturnType<typeof Gift.prototype.toObject>[]
        } = {}
        if (this.gifts != null) {
          data.gifts = this.gifts.map((item: Gift) => item.toObject())
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.gifts.length)
          writer.writeRepeatedMessage(1, this.gifts, (item: Gift) => item.serialize(writer))
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(message.gifts, () =>
                pb_1.Message.addToRepeatedWrapperField(message, 1, Gift.deserialize(reader), Gift)
              )
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      获取指定礼包信息
       **/
  export class GiftReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    static fromObject(data: { header?: ReturnType<typeof ReqHeader.prototype.toObject> }): GiftReq {
      const message = new GiftReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GiftReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GiftReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GiftReq {
      return GiftReq.deserialize(bytes)
    }
  }
  export class GiftResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: GiftResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(this, GiftResp.RespData, 2) as GiftResp.RespData
    }
    set data(value: GiftResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof GiftResp.RespData.prototype.toObject>
    }): GiftResp {
      const message = new GiftResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = GiftResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof GiftResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GiftResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new GiftResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = GiftResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): GiftResp {
      return GiftResp.deserialize(bytes)
    }
  }
  export namespace GiftResp {
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              gift?: Gift
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('gift' in data && data.gift != undefined) {
            this.gift = data.gift
          }
        }
      }
      get gift() {
        return pb_1.Message.getWrapperField(this, Gift, 1) as Gift
      }
      set gift(value: Gift) {
        pb_1.Message.setWrapperField(this, 1, value)
      }
      get has_gift() {
        return pb_1.Message.getField(this, 1) != null
      }
      static fromObject(data: { gift?: ReturnType<typeof Gift.prototype.toObject> }): RespData {
        const message = new RespData({})
        if (data.gift != null) {
          message.gift = Gift.fromObject(data.gift)
        }
        return message
      }
      toObject() {
        const data: {
          gift?: ReturnType<typeof Gift.prototype.toObject>
        } = {}
        if (this.gift != null) {
          data.gift = this.gift.toObject()
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.has_gift) writer.writeMessage(1, this.gift, () => this.gift.serialize(writer))
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(message.gift, () => (message.gift = Gift.deserialize(reader)))
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      ///////////////////////活动摘要数据获取///////////////////////////////
       获取摘要列表
       **/
  export class SummariesReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            apps?: number[]
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('apps' in data && data.apps != undefined) {
          this.apps = data.apps
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }

    /**
          指定要获取的活动摘要，不指定，获取所有可用活动的摘要
           **/
    get apps() {
      return pb_1.Message.getFieldWithDefault(this, 2, []) as number[]
    }

    /**
          指定要获取的活动摘要，不指定，获取所有可用活动的摘要
           **/
    set apps(value: number[]) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      apps?: number[]
    }): SummariesReq {
      const message = new SummariesReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.apps != null) {
        message.apps = data.apps
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        apps?: number[]
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.apps != null) {
        data.apps = this.apps
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.apps.length) writer.writePackedInt32(2, this.apps)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SummariesReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SummariesReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.apps = reader.readPackedInt32()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SummariesReq {
      return SummariesReq.deserialize(bytes)
    }
  }
  export class SummariesResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: SummariesResp.RespData
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }
    get data() {
      return pb_1.Message.getWrapperField(this, SummariesResp.RespData, 2) as SummariesResp.RespData
    }
    set data(value: SummariesResp.RespData) {
      pb_1.Message.setWrapperField(this, 2, value)
    }
    get has_data() {
      return pb_1.Message.getField(this, 2) != null
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: ReturnType<typeof SummariesResp.RespData.prototype.toObject>
    }): SummariesResp {
      const message = new SummariesResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = SummariesResp.RespData.fromObject(data.data)
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: ReturnType<typeof SummariesResp.RespData.prototype.toObject>
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data.toObject()
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.has_data) writer.writeMessage(2, this.data, () => this.data.serialize(writer))
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SummariesResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SummariesResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            reader.readMessage(
              message.data,
              () => (message.data = SummariesResp.RespData.deserialize(reader))
            )
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SummariesResp {
      return SummariesResp.deserialize(bytes)
    }
  }
  export namespace SummariesResp {
    export class RespData extends pb_1.Message {
      #one_of_decls: number[][] = []
      constructor(
        data?:
          | any[]
          | {
              Summary?: Summary[]
            }
      ) {
        super()
        pb_1.Message.initialize(
          this,
          Array.isArray(data) ? data : [],
          0,
          -1,
          [1],
          this.#one_of_decls
        )
        if (!Array.isArray(data) && typeof data == 'object') {
          if ('Summary' in data && data.Summary != undefined) {
            this.Summary = data.Summary
          }
        }
      }
      get Summary() {
        return pb_1.Message.getRepeatedWrapperField(this, Summary, 1) as Summary[]
      }
      set Summary(value: Summary[]) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value)
      }
      static fromObject(data: {
        Summary?: ReturnType<typeof Summary.prototype.toObject>[]
      }): RespData {
        const message = new RespData({})
        if (data.Summary != null) {
          message.Summary = data.Summary.map((item) => Summary.fromObject(item))
        }
        return message
      }
      toObject() {
        const data: {
          Summary?: ReturnType<typeof Summary.prototype.toObject>[]
        } = {}
        if (this.Summary != null) {
          data.Summary = this.Summary.map((item: Summary) => item.toObject())
        }
        return data
      }
      serialize(): Uint8Array
      serialize(w: pb_1.BinaryWriter): void
      serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter()
        if (this.Summary.length)
          writer.writeRepeatedMessage(1, this.Summary, (item: Summary) => item.serialize(writer))
        if (!w) return writer.getResultBuffer()
      }
      static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RespData {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
          message = new RespData()
        while (reader.nextField()) {
          if (reader.isEndGroup()) break
          switch (reader.getFieldNumber()) {
            case 1:
              reader.readMessage(message.Summary, () =>
                pb_1.Message.addToRepeatedWrapperField(
                  message,
                  1,
                  Summary.deserialize(reader),
                  Summary
                )
              )
              break
            default:
              reader.skipField()
          }
        }
        return message
      }
      serializeBinary(): Uint8Array {
        return this.serialize()
      }
      static deserializeBinary(bytes: Uint8Array): RespData {
        return RespData.deserialize(bytes)
      }
    }
  }

  /**
      /////////////////////////通用http代理消息协议/////////////////////////////
       **/
  export class ProxyReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: ReqHeader
            data?: Uint8Array
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, ReqHeader, 1) as ReqHeader
    }
    set header(value: ReqHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }

    /**
          约定的业务数据
           **/
    get data() {
      return pb_1.Message.getFieldWithDefault(this, 2, new Uint8Array(0)) as Uint8Array
    }

    /**
          约定的业务数据
           **/
    set data(value: Uint8Array) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof ReqHeader.prototype.toObject>
      data?: Uint8Array
    }): ProxyReq {
      const message = new ProxyReq({})
      if (data.header != null) {
        message.header = ReqHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = data.data
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof ReqHeader.prototype.toObject>
        data?: Uint8Array
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.data.length) writer.writeBytes(2, this.data)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ProxyReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ProxyReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = ReqHeader.deserialize(reader))
            )
            break
          case 2:
            message.data = reader.readBytes()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ProxyReq {
      return ProxyReq.deserialize(bytes)
    }
  }
  export class ProxyResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            header?: RespHeader
            data?: Uint8Array
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('header' in data && data.header != undefined) {
          this.header = data.header
        }
        if ('data' in data && data.data != undefined) {
          this.data = data.data
        }
      }
    }
    get header() {
      return pb_1.Message.getWrapperField(this, RespHeader, 1) as RespHeader
    }
    set header(value: RespHeader) {
      pb_1.Message.setWrapperField(this, 1, value)
    }
    get has_header() {
      return pb_1.Message.getField(this, 1) != null
    }

    /**
          约定的业务数据
           **/
    get data() {
      return pb_1.Message.getFieldWithDefault(this, 2, new Uint8Array(0)) as Uint8Array
    }

    /**
          约定的业务数据
           **/
    set data(value: Uint8Array) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: {
      header?: ReturnType<typeof RespHeader.prototype.toObject>
      data?: Uint8Array
    }): ProxyResp {
      const message = new ProxyResp({})
      if (data.header != null) {
        message.header = RespHeader.fromObject(data.header)
      }
      if (data.data != null) {
        message.data = data.data
      }
      return message
    }
    toObject() {
      const data: {
        header?: ReturnType<typeof RespHeader.prototype.toObject>
        data?: Uint8Array
      } = {}
      if (this.header != null) {
        data.header = this.header.toObject()
      }
      if (this.data != null) {
        data.data = this.data
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.has_header) writer.writeMessage(1, this.header, () => this.header.serialize(writer))
      if (this.data.length) writer.writeBytes(2, this.data)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ProxyResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ProxyResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            reader.readMessage(
              message.header,
              () => (message.header = RespHeader.deserialize(reader))
            )
            break
          case 2:
            message.data = reader.readBytes()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ProxyResp {
      return ProxyResp.deserialize(bytes)
    }
  }
}
